import React, { useState, useEffect } from 'react';
import { RiUserAddFill } from "react-icons/ri";
import { TbListDetails } from "react-icons/tb";
import { IoInformationCircle } from "react-icons/io5";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import './add-hr.css';
import { Button } from 'react-bootstrap';

const AddHR = () => {
  const [role, setRole] = useState(null);
  const [department, setDepartment] = useState(null);
  const [gender, setGender] = useState(null);
  const [country, setCountry] = useState(null);
  const [JoinDate, setjoinDate] = useState('');
  const [BirthDate, setdobDate] = useState('');
  const [status, setStatus] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [salary] = useState(0); // Add state for salary
  const [counter, setCounter] = useState(0); 
  const handleChange = (e) => {
    const value = Math.max(0, Number(e.target.value)); // Ensure the counter does not go below 0
    setCounter(value);
  };



  useEffect(() => {
    fetch('https://restcountries.com/v3.1/all')
      .then(response => response.json())
      .then(data => {
        const countryOptions = data.map(country => ({
          value: country.cca2,
          label: country.name.common
        }));
        setCountries(countryOptions);
      })
      .catch(error => console.error('Error fetching countries:', error));
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);

      // Handle file upload and form submission
      fetch('/your-upload-endpoint', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('File uploaded successfully:', data);
        // Proceed with additional form data submission if needed
      })
      .catch(error => console.error('Error uploading file:', error));
    } else {
      console.log('No file selected');
      // Proceed with form submission without file
    }

    // Further form data handling
    const formData = {
      role,
      department,
      JoinDate,
      BirthDate,
      country,
      gender,
      status,
      salary, // Include the status field
      // Include other form fields here
    };

    console.log('Form data:', formData);
    // You can now handle the form data as needed
  };
 

  const roleOptions = [
    { value: 'employee', label: 'Employee' },
    { value: 'admin', label: 'Admin' },
    { value: 'hr', label: 'HR' },
  ];

  const departmentOptions = [
    { value: 'hr', label: 'Human Resources (Manager)' },
    { value: 'employee', label: 'Employee' },
  ];

  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
  ];

  const statusOptions = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
  ];

  return (
    <div className='container-fluid'>
      <div className="hr-information-container">
        <h1 style={{ color: '#0353a4', textAlign: 'left',fontSize:'2rem',marginTop:'60px' }}>
          <RiUserAddFill /> Add HR
        </h1>
        <hr className="section-divider" />
        <h1 style={{ color: '#0353a4', textAlign: 'left',fontSize:'2rem' }}>
          <TbListDetails /> Login Details
        </h1>
        <hr className="section-divider" />
      </div>
      <Form onSubmit={handleSubmit} className="add-hr-form">

      <div className='add-hr-container'>
        <Form.Group as={Col} xs={12} md={5} controlId="formGridName">
          <Form.Label>Name<span className='required'>*</span>:</Form.Label>
          <Form.Control type="text" name="name" required placeholder="Enter Your Name" className="form-control" />
        </Form.Group>

        <Form.Group as={Col} xs={12} md={5} controlId="formGridUserName">
          <Form.Label>UserName <span className='required'>*</span>:</Form.Label>
          <Form.Control type="text" name="username" required placeholder="Enter Your UserName" className="form-control" />
        </Form.Group>

        <Form.Group as={Col} xs={12} md={5} controlId="formGridRole">
        <Form.Label>Role<span className='required'>*</span>:</Form.Label>
          <Select
            options={roleOptions}
            value={role}
            onChange={setRole}
            placeholder="--Select Role--"
          />
        </Form.Group>
      </div>

      <div>
        <h1 style={{ color: '#0353a4', textAlign: 'left',fontSize:'2rem',marginTop:'30px' }}>
          <IoInformationCircle /> HR Information
        </h1>
        <hr className="section-divider" />
      </div>

      <div>
        <div className="add-hr-container">
            <Row className="mb-3">
              <Form.Group as={Col} xs={12} md={5} controlId="formGridDepartment">
        <Form.Label>Departments<span className='required'>*</span>:</Form.Label>
                <Select
                  options={departmentOptions}
                  value={department}
                  onChange={setDepartment}
                  placeholder="--Department--"
                />
              </Form.Group>

              <Form.Group as={Col} xs={12} md={5} controlId="formGridStartDate">
                <Form.Label>Join Date <span className='required'>*</span> :</Form.Label>
                <Form.Control
                  type="date"
                  id="join_date"
                  name="join_date"
                  required
                  value={JoinDate}
                  onChange={(e) => setjoinDate(e.target.value)}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} xs={12} md={5} controlId="formGridJobTitle">
                <Form.Label>Job Title<span className='required'>*</span>:</Form.Label>
                <Form.Control type="text" name="job_title" className='form-control' />
              </Form.Group>

              <Form.Group as={Col} xs={12} md={5} controlId="formGridDOB">
                <Form.Label>DOB according to CNIC <span className='required'>*</span> :</Form.Label>
                <Form.Control
                  type="date"
                  id="dob"
                  name="dob"
                  required
                  value={BirthDate}
                  onChange={(e) => setdobDate(e.target.value)}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} xs={12} md={5} controlId="formGridExperience">
                <Form.Label>Work Experience<span className='required'>*</span> :</Form.Label>
                <Form.Control type="text" name='experience' className='form-control' />
              </Form.Group>

              <Form.Group as={Col} xs={12} md={5} controlId="formGridPhone">
                <Form.Label>Phone <span className='required'>*</span>:</Form.Label>
                <Form.Control type="text" name="phone" className='form-control' />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} xs={12} md={5} controlId="formGridWorkDescription">
                <Form.Label htmlFor="work_description">
                  Work Description <span className="required">*</span> :
                </Form.Label>
                <textarea
                  id="work_description"
                  className="form-control"
                  required
                  name="work_description"
                ></textarea>
              </Form.Group>

              <Form.Group as={Col} xs={12} md={5} controlId="formGridCountry">
        <Form.Label>Country<span className='required'>*</span>:</Form.Label>
                <Select
                  options={countries}
                  value={country}
                  onChange={setCountry}
                  placeholder="--Select Country--"
                />
              </Form.Group>
            </Row>
            
            <Row className="mb-3">
              <Form.Group as={Col} xs={12} md={5} controlId="formGridEmail">
                <Form.Label>E-mail<span className='required'>*</span> :</Form.Label>
                <Form.Control type="email" name='email' className='form-control' />
              </Form.Group>

              <Form.Group as={Col} xs={12} md={5} controlId="formGridCity">
                <Form.Label>City <span className='required'>*</span>:</Form.Label>
                <Form.Control type="text" name="city" className='form-control' />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} xs={12} md={5} controlId="formGridGender">
              <Form.Label>Gender<span className='required'>*</span>:</Form.Label>
                <Select
                  options={genderOptions}
                  value={gender}
                  onChange={setGender}
                  placeholder="--Select Gender--"
                />
              </Form.Group>

              <Form.Group as={Col} xs={12} md={5} controlId="formGridCity">
                <Form.Label>Address <span className='required'>*</span>:</Form.Label>
                <Form.Control type="text" name="address" className='form-control' />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} xs={12} md={5} controlId="formGridFile">
                <Form.Label>Profile picture<span className='required'>*</span> :</Form.Label>
                <Form.Control type="file" onChange={handleFileChange} />
              </Form.Group>
              <Form.Group as={Col} xs={12} md={5} controlId="formGridStatus">
              <Form.Label>Marital Status<span className='required'>*</span> :</Form.Label>
                <Select
                  options={statusOptions}
                  value={status}
                  onChange={setStatus}
                  placeholder="--Select Marital Status--"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} xs={12} md={5} controlId="formGridFile">
                <Form.Label>ID Card<span className='required'>*</span> :</Form.Label>
                <Form.Control type="file" onChange={handleFileChange} />
              </Form.Group>
              <Form.Group as={Col} xs={12} md={5} controlId="formGridCity">
             
             <label htmlFor='holiday-counter'>
              Salary<span className='required'>*</span>
             </label>
             <Form.Control
               type='number'
               id='salary-counter'
               name='salary-counter'
               value={counter}
               onChange={handleChange}
               min='0' // Prevent negative values
               step='1' // Set increment step
               className='form-control' // Ensure it uses the same styling as other inputs
             />
    </Form.Group>
            </Row>
            <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={5} controlId="formGridFile">
                <Form.Label>ID Card (Back Side)<span className='required'>*</span> :</Form.Label>
                <Form.Control type="file" onChange={handleFileChange} />
              </Form.Group>
              <Form.Group as={Col} xs={12} md={5} controlId="formGridFile">
                <Form.Label>CV<span className='required'>*</span> :</Form.Label>
                <Form.Control type="file" accept=".pdf" onChange={handleFileChange} />
              </Form.Group>
            </Row>
            <Row>
            <Form.Group as={Col} xs={12} md={5} controlId="formGridFile">
                <Form.Label>Past Work Certificate<span className='required'>*</span> :</Form.Label>
                <Form.Control type="file" accept=".pdf" onChange={handleFileChange} />
              </Form.Group>
            </Row>
            <Row>
  <Form.Group as={Col} xs={12}>
    <Button type="submit" variant='primary'style={{marginTop:'10px'}}>Add HR</Button>
  </Form.Group>
</Row>         

        </div>
      </div>
      </Form>
    </div>
  );
};

export default AddHR;
